import { navigateToExternalResource } from '@app/utils'

export const useExternalNavigate = (): typeof navigateToExternalResource => {
  return navigateToExternalResource
}
